import axios from "axios";

export interface AddFoodDrawal {
  companyId: string;
  companyLocationId: string;
  registratedUser: string;
  foodDrawalDate: string;
  expirtyDate: string;
  quantityReceivedDate: string;
  isUsed: string;
  file?: string;
  correctiveAction: string;
  supplierId: string;
  foodName?: string;
}

export interface FoodDrawal extends AddFoodDrawal {
  id: string;
  status: string;
  creationDate: string;
}

export function addFoodDrawal(foodDrawal: AddFoodDrawal) {
  return axios
    .post(`/FoodDrawals/addfooddrawal`, foodDrawal)
    .then((res) => res.data);
}

export function getAllFoodDrawalsByLocationId(companyLocationId: string) {
  return axios
    .get<FoodDrawal[]>(`/FoodDrawals/getallfooddrawalsbylocationid`, {
      params: { companyLocationId },
    })
    .then((res) => res.data);
}

export function updateFoodDrawal(foodDrawal: Omit<FoodDrawal, "creationDate">) {
  return axios
    .put(`/FoodDrawals/updatefooddrawal`, foodDrawal)
    .then((res) => res.data);
}

export function getFoodDrawalById(id: string) {
  return axios
    .get<FoodDrawal>("/FoodDrawals/getfooddrawalbyid", {
      params: { id: id },
    })
    .then((res) => res.data);
}
